// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"99ba411b","977":"b0ab4eb8"}[chunkId] + ".chunk.js";
};